import {useState} from "react";
import activeCountries from "../activeCountries";
import {SELECTED_COUNTRY_KEY} from "../CountryContext";

const useActiveCountry = () => {
  let country = null;
  const countryCode = window.location.pathname.split("/")?.[1];

  if (
    typeof window !== "undefined" &&
    localStorage.getItem(SELECTED_COUNTRY_KEY) &&
    activeCountries
      .map((c) => c.code)
      .indexOf(localStorage.getItem(SELECTED_COUNTRY_KEY)) >= 0
  ) {
    country = activeCountries.find(
      (c) => c.code === localStorage.getItem(SELECTED_COUNTRY_KEY)
    );
  }

  if (
    countryCode &&
    activeCountries.map((c) => c.code).indexOf(countryCode) >= 0
  ) {
    country = activeCountries.find((c) => c.code === countryCode);

    localStorage.setItem(SELECTED_COUNTRY_KEY, country.code);
    // localStorage.setItem(LANGUAGE_KEY, country.defaultLanguage);
  }

  return useState(country);
};

export default useActiveCountry;
